var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotorAsincronTrifazatCuRotorulInScurtcircuitTriunghi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 80,
    viewBox: "0 0 76 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 40C2 20.1177 18.1177 4 38 4C57.8823 4 74 20.1177 74 40C74 59.8823 57.8823 76 38 76C18.1177 76 2 59.8823 2 40Z",
    fill: "white",
    stroke: "#FC7900",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7465 50.75L38.5 20L56.2535 50.75H20.7465Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0525 13.7429C63.0527 13.2423 60.9137 28.5518 61.5528 30.2422",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25.1172L61.7901 30.6721",
    stroke: "black",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.198 24.0008L61.4194 31.9961",
    stroke: "black",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorAsincronTrifazatCuRotorulInScurtcircuitTriunghi);
export default __webpack_public_path__ + "static/media/motor_asincron_trifazat_cu_rotorul_in_scurtcircuit_triunghi.c9e9e405053d010d9e8cd175f25119f8.svg";
export { ForwardRef as ReactComponent };